<div class="search-container">
  <div class="search-wrapper">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      type="text"
      class="search-input"
      placeholder="Search products..."
      (input)="onSearchChange($event)"
      (focus)="onSearchFocus()"
      (blur)="onSearchBlur()"
      [matAutocomplete]="auto"
      #searchInput
      [value]="searchQuery"
    />
    <button
      mat-icon-button
      class="clear-button"
      *ngIf="searchQuery"
      (click)="clearSearch()"
      type="button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Material Autocomplete -->
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option
      *ngFor="let result of searchResults; trackBy: trackByResult"
      [value]="result"
      (onSelectionChange)="onResultClick(result)"
      class="search-result-option"
    >
      <div class="result-content">
        <img
          *ngIf="result.type === 'product' || result.type === 'brand'; else resultIcon"
          class="result-image"
          [class.result-image--brand]="result.type === 'brand'"
          [class.result-image--product]="result.type === 'product'"
          [src]="result.image || ''"
          [alt]="result.name"
        />

        <ng-template #resultIcon>
          <mat-icon class="result-icon">
          <ng-container [ngSwitch]="result.type">
            <span *ngSwitchCase="'product'">local_offer</span>
            <span *ngSwitchCase="'brand'">storefront</span>
            <span *ngSwitchCase="'category'">category</span>
            <span *ngSwitchCase="'color'">palette</span>
            <span *ngSwitchDefault>search</span>
          </ng-container>
          </mat-icon>
        </ng-template>

        <!-- Result Text -->
        <div class="result-text">
          <span class="result-name">{{ result.name }}</span>

          <!-- Product metadata -->
          <div class="result-meta" *ngIf="result.type === 'product'">
            <span *ngIf="result.brand">{{ result.brand }}</span>
            <span *ngIf="result.brand && result.colour"> • </span>
            <span *ngIf="result.colour">{{ result.colour }}</span>
          </div>

          <!-- Other type labels -->
          <div class="result-meta" *ngIf="result.type !== 'product'">
            {{ getTypeLabel(result.type) }}
          </div>
        </div>

        <!-- Result Badge -->
        <mat-chip class="result-badge">
          {{ result.type }}
        </mat-chip>
      </div>
    </mat-option>

    <!-- No results -->
    <mat-option
      *ngIf="searchQuery && searchResults.length === 0"
      [value]="null"
      disabled
      class="no-results-option"
    >
      <div class="no-results-content">
        <mat-icon>search_off</mat-icon>
        <span>No results found for "{{ searchQuery }}"</span>
      </div>
    </mat-option>
  </mat-autocomplete>
</div>
